<template>
  <div>
    <vue-headful :title="doctitle" />
    <TopLandingSection />
    <MeetTheExperts />
    <ThemeIntroduction />
    <Mashup />
  </div>
</template>

<script>
import { tagsMixin } from "../mixins/tagsMixin";
import TopLandingSection from "./TopLandingSection.vue";
import Mashup from "./Mashup.vue";
import ThemeIntroduction from "./ThemeIntroduction.vue";
import MeetTheExperts from "./MeetTheExperts.vue";

export default {
  name: "Hello",
  components: {
    TopLandingSection,
    Mashup,
    ThemeIntroduction,
    MeetTheExperts,
  },
  mixins: [tagsMixin],
  data() {
    return {
      doctitle: this.$store.state.conferencename,
    };
  },
  methods: {
    goRouter: function () {
      this.$router.push({ path: "line-up" });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/variables.scss";
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue